<div class="h-[calc(100vh-64px)] flex bg-gray-900">

  <!-- Left Sidebar -->
  <div class="w-64 flex-shrink-0 border-r border-gray-700 flex flex-col">
    <div class="px-4 pt-5 pb-3 flex items-center justify-between">
      <h1 class="text-lg font-bold text-white">Kennisbank</h1>
      <button *ngIf="isAdmin" (click)="forceSeed()" class="p-1.5 text-gray-600 hover:text-indigo-400 transition-colors" title="Content herladen">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </button>
    </div>

    <!-- Search -->
    <div class="px-3 pb-3">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        placeholder="Zoeken..."
        class="w-full px-3 py-1.5 bg-gray-800 border border-gray-700 rounded-md text-xs text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-indigo-500">
    </div>

    <!-- Categories & Articles -->
    <div class="flex-1 overflow-y-auto px-2 pb-4">
      <div *ngIf="loading" class="px-3 py-4 text-xs text-gray-500">Laden...</div>

      <div *ngFor="let category of filteredCategories" class="mb-1">
        <div class="flex items-center group">
          <button
            (click)="toggleCategory(category)"
            class="flex-1 flex items-center gap-2 px-2 py-1.5 rounded-md text-left hover:bg-gray-800 transition-colors">
            <svg class="w-3 h-3 text-gray-500 transition-transform" [class.rotate-90]="category.expanded" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
            <span class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{ category.title }}</span>
          </button>
          <button *ngIf="isAdmin"
            (click)="deleteCategory(category); $event.stopPropagation()"
            class="p-1 text-gray-600 hover:text-red-400 opacity-0 group-hover:opacity-100 transition-all" title="Verwijderen">
            <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div *ngIf="category.expanded" class="ml-3 border-l border-gray-700/50">
          <button
            *ngFor="let article of category.articles"
            (click)="openArticle(category, article)"
            class="w-full flex items-center justify-between gap-1 px-3 py-1.5 text-left text-xs rounded-r-md transition-colors group/art"
            [ngClass]="selectedArticle?.article === article ? 'bg-indigo-600/20 text-indigo-300 border-l-2 border-indigo-500 -ml-px' : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800'">
            <span class="truncate">{{ article.title }}</span>
            <button *ngIf="isAdmin"
              (click)="deleteArticle(category, article); $event.stopPropagation()"
              class="p-0.5 text-gray-600 hover:text-red-400 opacity-0 group-hover/art:opacity-100 flex-shrink-0" title="Verwijderen">
              <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </button>

          <!-- Add article button -->
          <div *ngIf="isAdmin && addingArticleToCategoryId === category.id" class="px-3 py-2">
            <input type="text" [(ngModel)]="newArticleTitle" placeholder="Artikel titel"
              (keydown.enter)="addArticle(category.id)"
              class="w-full px-2 py-1 bg-gray-800 border border-gray-600 rounded text-xs text-gray-200 focus:ring-1 focus:ring-indigo-500 focus:outline-none">
            <div class="flex gap-1 mt-1">
              <button (click)="addArticle(category.id)" class="text-[10px] text-indigo-400 hover:text-indigo-300">Toevoegen</button>
              <button (click)="addingArticleToCategoryId = null" class="text-[10px] text-gray-500 hover:text-gray-300">Annuleren</button>
            </div>
          </div>
          <button *ngIf="isAdmin && addingArticleToCategoryId !== category.id"
            (click)="addingArticleToCategoryId = category.id; newArticleTitle = ''"
            class="w-full px-3 py-1 text-[10px] text-gray-600 hover:text-gray-400 text-left transition-colors">
            + artikel
          </button>
        </div>
      </div>

      <!-- Add category -->
      <div *ngIf="isAdmin" class="mt-3 px-1">
        <div *ngIf="showAddCategory" class="bg-gray-800 rounded-lg p-3 border border-gray-700">
          <input type="text" [(ngModel)]="newCategoryTitle" placeholder="Categorie naam"
            class="w-full px-2 py-1 bg-gray-900 border border-gray-600 rounded text-xs text-gray-200 mb-2 focus:ring-1 focus:ring-indigo-500 focus:outline-none">
          <div class="flex gap-1">
            <button (click)="addCategory()" class="text-[10px] text-indigo-400 hover:text-indigo-300">Toevoegen</button>
            <button (click)="showAddCategory = false" class="text-[10px] text-gray-500 hover:text-gray-300">Annuleren</button>
          </div>
        </div>
        <button *ngIf="!showAddCategory"
          (click)="showAddCategory = true; newCategoryTitle = ''; newCategoryDescription = ''"
          class="w-full py-1.5 text-[10px] text-gray-600 hover:text-gray-400 transition-colors">
          + categorie
        </button>
      </div>

      <!-- Empty search -->
      <div *ngIf="filteredCategories.length === 0 && searchTerm && !loading" class="text-center py-8">
        <p class="text-xs text-gray-500">Geen resultaten</p>
      </div>
    </div>
  </div>

  <!-- Right Content -->
  <div class="flex-1 overflow-y-auto">
    <div *ngIf="!selectedArticle" class="flex items-center justify-center h-full">
      <div class="text-center">
        <h2 class="text-lg font-semibold text-gray-500 mb-1">Selecteer een artikel</h2>
        <p class="text-sm text-gray-600">Kies een onderwerp uit het menu</p>
      </div>
    </div>

    <div *ngIf="selectedArticle" class="max-w-2xl mx-auto px-8 py-8">
      <div class="flex items-center justify-between mb-6">
        <div>
          <div class="text-xs text-indigo-400 font-medium mb-1">{{ selectedArticle.category.title }}</div>
          <h2 *ngIf="!editingArticle" class="text-2xl font-bold text-white">{{ selectedArticle.article.title }}</h2>
          <input *ngIf="editingArticle" type="text" [(ngModel)]="editTitle"
            class="text-2xl font-bold text-white bg-transparent border-b border-gray-600 focus:border-indigo-500 outline-none w-full pb-1">
        </div>
        <button *ngIf="isAdmin && !editingArticle"
          (click)="startEditArticle()"
          class="p-2 text-gray-500 hover:text-indigo-400 transition-colors" title="Bewerken">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </button>
      </div>

      <!-- Read mode: render blocks -->
      <div *ngIf="!editingArticle" class="space-y-4">
        <ng-container *ngFor="let block of selectedArticle.article.blocks">
          <p *ngIf="block.type === 'text'" class="text-sm text-gray-300 leading-relaxed whitespace-pre-line">{{ block.value }}</p>
          <h3 *ngIf="block.type === 'title'" class="text-lg font-semibold text-white mt-6 mb-2">{{ block.value }}</h3>
          <img *ngIf="block.type === 'image' && block.value" [src]="block.value" class="rounded-lg max-w-full" loading="lazy">
        </ng-container>
        <!-- Fallback for legacy content without blocks -->
        <p *ngIf="selectedArticle.article.blocks.length === 0" class="text-sm text-gray-300 leading-relaxed whitespace-pre-line">{{ selectedArticle.article.content }}</p>
      </div>

      <!-- Edit mode: block editor -->
      <div *ngIf="editingArticle" class="space-y-3">
        <div *ngFor="let block of editBlocks; let i = index"
             class="group relative bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
          <!-- Block toolbar -->
          <div class="flex items-center justify-between px-3 py-1.5 bg-gray-800 border-b border-gray-700">
            <span class="text-[10px] text-gray-500 uppercase tracking-wider">
              {{ block.type === 'text' ? 'Tekst' : block.type === 'title' ? 'Titel' : 'Afbeelding' }}
            </span>
            <div class="flex items-center gap-1">
              <button *ngIf="i > 0" (click)="moveBlockUp(i)" class="p-1 text-gray-500 hover:text-gray-300">
                <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"/></svg>
              </button>
              <button *ngIf="i < editBlocks.length - 1" (click)="moveBlockDown(i)" class="p-1 text-gray-500 hover:text-gray-300">
                <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg>
              </button>
              <button (click)="removeBlock(i)" class="p-1 text-gray-500 hover:text-red-400">
                <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
              </button>
            </div>
          </div>

          <!-- Text block -->
          <textarea *ngIf="block.type === 'text'"
            [(ngModel)]="block.value" rows="4"
            class="w-full bg-transparent text-sm text-gray-300 leading-relaxed p-3 focus:outline-none resize-y"
            placeholder="Schrijf tekst..."></textarea>

          <!-- Title block -->
          <input *ngIf="block.type === 'title'" type="text"
            [(ngModel)]="block.value"
            class="w-full bg-transparent text-lg font-semibold text-white px-3 py-2 focus:outline-none"
            placeholder="Titel...">

          <!-- Image block -->
          <div *ngIf="block.type === 'image'" class="p-3">
            <img *ngIf="block.value" [src]="block.value" class="rounded-lg max-w-full max-h-48 object-cover mb-2">
            <label class="inline-flex items-center px-3 py-1.5 text-xs text-gray-400 bg-gray-700 rounded-md cursor-pointer hover:bg-gray-600 transition-colors">
              {{ uploadingBlockIndex === i ? 'Uploaden...' : (block.value ? 'Wijzigen' : 'Afbeelding kiezen') }}
              <input type="file" accept="image/*" class="hidden" (change)="uploadBlockImage($event, i)" [disabled]="uploadingBlockIndex !== null">
            </label>
          </div>
        </div>

        <!-- Add block buttons -->
        <div class="flex items-center gap-2 pt-2">
          <button (click)="addBlock('text')" class="px-3 py-1.5 text-xs text-gray-400 bg-gray-800 border border-gray-700 rounded-md hover:bg-gray-700 hover:text-gray-200 transition-colors">+ Tekst</button>
          <button (click)="addBlock('title')" class="px-3 py-1.5 text-xs text-gray-400 bg-gray-800 border border-gray-700 rounded-md hover:bg-gray-700 hover:text-gray-200 transition-colors">+ Titel</button>
          <button (click)="addBlock('image')" class="px-3 py-1.5 text-xs text-gray-400 bg-gray-800 border border-gray-700 rounded-md hover:bg-gray-700 hover:text-gray-200 transition-colors">+ Afbeelding</button>
        </div>

        <!-- Save/Cancel -->
        <div class="flex gap-2 pt-4 border-t border-gray-700">
          <button (click)="saveArticle()" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm rounded-lg transition-colors">Opslaan</button>
          <button (click)="cancelEditArticle()" class="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 text-sm rounded-lg transition-colors">Annuleren</button>
        </div>
      </div>
    </div>
  </div>
</div>
